import PatientInChair from '../../../common/icons/PatientInChair';
import Toothbrush from '../../../common/icons/Toothbrush';
import ToothDamage from '../../../common/icons/ToothDamage';
import ToothPain from '../../../common/icons/ToothPain';
import Urgent from '../../../common/icons/Urgent';

export const CHOICES = {
  CHECKUP_CLEANING: 'checkup',
  SPECIFIC_TREATMENT: 'services',
  URGENT_ISSUE: 'urgent',
};

export const SUB_ROUTES = {
  [CHOICES.SPECIFIC_TREATMENT]: {
    path: 'services',
  },
  [CHOICES.URGENT_ISSUE]: {
    path: 'urgent-issue',
  },
};

export const reasons = [
  {
    id: CHOICES.CHECKUP_CLEANING,
    reasonPartnerId: 1002,
    title: 'Checkup & Cleaning',
    description: 'Routine visit',
    icon: Toothbrush,
  },
  {
    id: CHOICES.SPECIFIC_TREATMENT,
    title: 'Specific Treatment',
    description: 'E.g. Crown, root canal',
    icon: PatientInChair,
  },
  {
    id: CHOICES.URGENT_ISSUE,
    title: 'Urgent Issue',
    description: 'E.g. Damaged tooth, pain',
    icon: Urgent,
  },
];

export const treatments = [
  {
    id: 3,
    reasonPartnerId: 1027,
    title: 'Braces / Invisalign',
    description:
      'Orthodontic treatment uses Braces, Invisalign, or other appliances to put gentle pressure on your teeth and eventually move them into the right position.',
  },
  {
    id: 5,
    reasonPartnerId: 1012,
    title: 'Bridges / Dentures',
    description:
      'Bridges and dentures are used to replace missing or badly damaged teeth.',
  },
  {
    id: 9,
    reasonPartnerId: 1007,
    title: 'Crown / Cap',
    description:
      'A crown (also called a cap) is used to reinforce the damaged part of your tooth protecting it from further damage.',
  },
  {
    id: 8,
    reasonPartnerId: 1011,
    title: 'Implants',
    description:
      'Dental implants are used to replace missing roots and support replacement teeth.',
  },
  {
    id: 10,
    reasonPartnerId: 1021,
    title: 'Root Canal',
    description:
      'Root canals treat diseases or abscessed teeth. Once a tooth is injured, cracked, or decayed, it is necessary to open the tooth and clean out the infected tissue in the centre. This space is then filled and the opening sealed.',
  },
  {
    id: 11,
    reasonPartnerId: 1024,
    title: 'Tooth Extraction',
    description: 'A severely damaged tooth may need to be extracted.',
  },
  {
    id: 7,
    reasonPartnerId: 6,
    title: 'Whitening',
    description:
      'Tooth whitening lightens teeth and helps to remove stains and discolouration.',
  },
  {
    id: 4,
    title: 'Wisdom Teeth',
    reasonPartnerId: 1025,
    data: 'Wisdom Teeth Removal',
    description:
      "When the jaw isn't large enough to accommodate wisdom teeth, they can become impacted. Wisdom teeth may grow sideways, emerge only part way from the gum, or remain trapped beneath the gum and bone.",
  },
  {
    id: 17,
    title: 'Cavity',
    reasonPartnerId: 1006,
    data: 'Cavity',
    description:
      'A cavity is a hole in a tooth that develops from tooth decay.',
  },
  {
    id: 18,
    title: 'Gum Disease',
    reasonPartnerId: 1009,
    data: 'Gum Disease',
    description:
      'Gum disease causes inflammation of the gums, bones and tissues that surround and support teeth.',
  },
];

export const urgentIssues = [
  {
    id: 'pain',
    reasonPartnerId: 1004,
    title: 'Pain',
    icon: ToothPain,
  },
  {
    id: 'damaged-tooth',
    reasonPartnerId: 1010,
    title: 'Damaged Tooth',
    icon: ToothDamage,
  },
];
